import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import {  
  // Weekly Availability
  getMyWeeklyScheduleForForm,
  updateMyWeeklySchedule,
  getMyWeeklyScheduleSummary,
  checkWeeklyTimeConflict,
    
  // Availability Checking
  checkProviderAvailability,
  getProviderAvailabilityForDateRange,
  batchCheckProviderAvailability,
  
  // Convenience Methods
  getProviderFullAvailability,
  checkBusinessHoursAvailability,
  getAvailableProviders,
} from '../../util/api';

// ================ Action types ================ //

// Weekly Schedule
export const FETCH_WEEKLY_SCHEDULE_REQUEST = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_REQUEST';
export const FETCH_WEEKLY_SCHEDULE_SUCCESS = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_SUCCESS';
export const FETCH_WEEKLY_SCHEDULE_ERROR = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_ERROR';

export const UPDATE_WEEKLY_SCHEDULE_REQUEST = 'app/ProviderAvailabilityPage/UPDATE_WEEKLY_SCHEDULE_REQUEST';
export const UPDATE_WEEKLY_SCHEDULE_SUCCESS = 'app/ProviderAvailabilityPage/UPDATE_WEEKLY_SCHEDULE_SUCCESS';
export const UPDATE_WEEKLY_SCHEDULE_ERROR = 'app/ProviderAvailabilityPage/UPDATE_WEEKLY_SCHEDULE_ERROR';

export const VALIDATE_WEEKLY_SCHEDULE_REQUEST = 'app/ProviderAvailabilityPage/VALIDATE_WEEKLY_SCHEDULE_REQUEST';
export const VALIDATE_WEEKLY_SCHEDULE_SUCCESS = 'app/ProviderAvailabilityPage/VALIDATE_WEEKLY_SCHEDULE_SUCCESS';
export const VALIDATE_WEEKLY_SCHEDULE_ERROR = 'app/ProviderAvailabilityPage/VALIDATE_WEEKLY_SCHEDULE_ERROR';

export const FETCH_WEEKLY_SCHEDULE_SUMMARY_REQUEST = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_SUMMARY_REQUEST';
export const FETCH_WEEKLY_SCHEDULE_SUMMARY_SUCCESS = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_SUMMARY_SUCCESS';
export const FETCH_WEEKLY_SCHEDULE_SUMMARY_ERROR = 'app/ProviderAvailabilityPage/FETCH_WEEKLY_SCHEDULE_SUMMARY_ERROR';

// Availability Checking
export const CHECK_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityPage/CHECK_AVAILABILITY_REQUEST';
export const CHECK_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityPage/CHECK_AVAILABILITY_SUCCESS';
export const CHECK_AVAILABILITY_ERROR = 'app/ProviderAvailabilityPage/CHECK_AVAILABILITY_ERROR';

export const BATCH_CHECK_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityPage/BATCH_CHECK_AVAILABILITY_REQUEST';
export const BATCH_CHECK_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityPage/BATCH_CHECK_AVAILABILITY_SUCCESS';
export const BATCH_CHECK_AVAILABILITY_ERROR = 'app/ProviderAvailabilityPage/BATCH_CHECK_AVAILABILITY_ERROR';

export const GET_AVAILABILITY_STATS_REQUEST = 'app/ProviderAvailabilityPage/GET_AVAILABILITY_STATS_REQUEST';
export const GET_AVAILABILITY_STATS_SUCCESS = 'app/ProviderAvailabilityPage/GET_AVAILABILITY_STATS_SUCCESS';
export const GET_AVAILABILITY_STATS_ERROR = 'app/ProviderAvailabilityPage/GET_AVAILABILITY_STATS_ERROR';

// ================ Reducer ================ //

const initialState = {
  // Weekly Schedule
  fetchWeeklyScheduleInProgress: false,
  fetchWeeklyScheduleError: null,
  updateScheduleInProgress: false,
  updateScheduleError: null,
  validateScheduleInProgress: false,
  validateScheduleError: null,
  validationResult: null,
  fetchScheduleSummaryInProgress: false,
  fetchScheduleSummaryError: null,
  weeklyScheduleSummary: null,

  // Availability Checking
  checkAvailabilityInProgress: false,
  checkAvailabilityError: null,
  batchCheckAvailabilityInProgress: false,
  batchCheckAvailabilityError: null,
  getAvailabilityStatsInProgress: false,
  getAvailabilityStatsError: null,
  
  // Data
  weeklySchedule: null,
  availabilityCheck: null,
  batchAvailabilityCheck: null,
  availabilityStats: null,
  pagination: null,
};

export default function providerAvailabilityPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  
  switch (type) {
    // Weekly Schedule
    case FETCH_WEEKLY_SCHEDULE_REQUEST:
      return { ...state, fetchWeeklyScheduleInProgress: true, fetchWeeklyScheduleError: null };
    case FETCH_WEEKLY_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchWeeklyScheduleInProgress: false,
        weeklySchedule: payload.success ? payload.data : payload.data,
        pagination: payload.meta,
      };
    case FETCH_WEEKLY_SCHEDULE_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchWeeklyScheduleInProgress: false, fetchWeeklyScheduleError: payload };

    // Weekly Schedule - NEW FOR FORM
    case UPDATE_WEEKLY_SCHEDULE_REQUEST:
      return { ...state, updateScheduleInProgress: true, updateScheduleError: null };
    case UPDATE_WEEKLY_SCHEDULE_SUCCESS:
      return {
        ...state,
        updateScheduleInProgress: false,
        weeklySchedule: payload,
        updateScheduleError: null,
      };
    case UPDATE_WEEKLY_SCHEDULE_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, updateScheduleInProgress: false, updateScheduleError: payload };

    case VALIDATE_WEEKLY_SCHEDULE_REQUEST:
      return { ...state, validateScheduleInProgress: true, validateScheduleError: null };
    case VALIDATE_WEEKLY_SCHEDULE_SUCCESS:
      return {
        ...state,
        validateScheduleInProgress: false,
        validationResult: payload,
        validateScheduleError: null,
      };
    case VALIDATE_WEEKLY_SCHEDULE_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, validateScheduleInProgress: false, validateScheduleError: payload };

    case FETCH_WEEKLY_SCHEDULE_SUMMARY_REQUEST:
      return { ...state, fetchScheduleSummaryInProgress: true, fetchScheduleSummaryError: null };
    case FETCH_WEEKLY_SCHEDULE_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchScheduleSummaryInProgress: false,
        weeklyScheduleSummary: payload.data,
        fetchScheduleSummaryError: null,
      };
    case FETCH_WEEKLY_SCHEDULE_SUMMARY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchScheduleSummaryInProgress: false, fetchScheduleSummaryError: payload };

    // Availability Checking
    case CHECK_AVAILABILITY_REQUEST:
      return { ...state, checkAvailabilityInProgress: true, checkAvailabilityError: null };
    case CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        checkAvailabilityInProgress: false,
        availabilityCheck: payload.data,
        pagination: payload.meta,
      };
    case CHECK_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, checkAvailabilityInProgress: false, checkAvailabilityError: payload };

    case BATCH_CHECK_AVAILABILITY_REQUEST:
      return { ...state, batchCheckAvailabilityInProgress: true, batchCheckAvailabilityError: null };
    case BATCH_CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        batchCheckAvailabilityInProgress: false,
        batchAvailabilityCheck: payload.data,
        pagination: payload.meta,
      };
    case BATCH_CHECK_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, batchCheckAvailabilityInProgress: false, batchCheckAvailabilityError: payload };

    case GET_AVAILABILITY_STATS_REQUEST:
      return { ...state, getAvailabilityStatsInProgress: true, getAvailabilityStatsError: null };
    case GET_AVAILABILITY_STATS_SUCCESS:
      return {
        ...state,
        getAvailabilityStatsInProgress: false,
        availabilityStats: payload.data,
        pagination: payload.meta,
      };
    case GET_AVAILABILITY_STATS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, getAvailabilityStatsInProgress: false, getAvailabilityStatsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

// Weekly Schedule
const fetchWeeklyScheduleRequest = () => ({ type: FETCH_WEEKLY_SCHEDULE_REQUEST });
const fetchWeeklyScheduleSuccess = response => ({
  type: FETCH_WEEKLY_SCHEDULE_SUCCESS,
  payload: response,
});
const fetchWeeklyScheduleError = e => ({
  type: FETCH_WEEKLY_SCHEDULE_ERROR,
  error: true,
  payload: e,
});

const updateWeeklyScheduleRequest = () => ({ type: UPDATE_WEEKLY_SCHEDULE_REQUEST });
const updateWeeklyScheduleSuccess = response => ({
  type: UPDATE_WEEKLY_SCHEDULE_SUCCESS,
  payload: response,
});
const updateWeeklyScheduleError = e => ({
  type: UPDATE_WEEKLY_SCHEDULE_ERROR,
  error: true,
  payload: e,
});

const validateWeeklyScheduleRequest = () => ({ type: VALIDATE_WEEKLY_SCHEDULE_REQUEST });
const validateWeeklyScheduleSuccess = response => ({
  type: VALIDATE_WEEKLY_SCHEDULE_SUCCESS,
  payload: response,
});
const validateWeeklyScheduleError = e => ({
  type: VALIDATE_WEEKLY_SCHEDULE_ERROR,
  error: true,
  payload: e,
});

const fetchWeeklyScheduleSummaryRequest = () => ({ type: FETCH_WEEKLY_SCHEDULE_SUMMARY_REQUEST });
const fetchWeeklyScheduleSummarySuccess = response => ({
  type: FETCH_WEEKLY_SCHEDULE_SUMMARY_SUCCESS,
  payload: response,
});
const fetchWeeklyScheduleSummaryError = e => ({
  type: FETCH_WEEKLY_SCHEDULE_SUMMARY_ERROR,
  error: true,
  payload: e,
});

// Availability Checking
const checkAvailabilityRequest = () => ({ type: CHECK_AVAILABILITY_REQUEST });
const checkAvailabilitySuccess = response => ({
  type: CHECK_AVAILABILITY_SUCCESS,
  payload: response,
});
const checkAvailabilityError = e => ({
  type: CHECK_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const batchCheckAvailabilityRequest = () => ({ type: BATCH_CHECK_AVAILABILITY_REQUEST });
const batchCheckAvailabilitySuccess = response => ({
  type: BATCH_CHECK_AVAILABILITY_SUCCESS,
  payload: response,
});
const batchCheckAvailabilityError = e => ({
  type: BATCH_CHECK_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const getAvailabilityStatsRequest = () => ({ type: GET_AVAILABILITY_STATS_REQUEST });
const getAvailabilityStatsSuccess = response => ({
  type: GET_AVAILABILITY_STATS_SUCCESS,
  payload: response,
});
const getAvailabilityStatsError = e => ({
  type: GET_AVAILABILITY_STATS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const PAGE_SIZE = 20;

export const fetchWeeklySchedule = () => (dispatch, getState, sdk) => {
  dispatch(fetchWeeklyScheduleRequest());

  return getMyWeeklyScheduleForForm()
    .then(response => {
      dispatch(fetchWeeklyScheduleSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchWeeklyScheduleError(storableError(e)));
      throw e;
    });
};

export const updateWeeklySchedule = (scheduleData) => (dispatch, getState, sdk) => {
  dispatch(updateWeeklyScheduleRequest());

  return updateMyWeeklySchedule(scheduleData)
    .then(result => {
      if (result.success) {
        // Fetch the updated schedule to get the latest data
        return getMyWeeklyScheduleForForm();
      } else {
        throw new Error(result.error || 'Failed to update weekly schedule');
      }
    })
    .then(fetchResult => {
      if (fetchResult.success) {
        dispatch(updateWeeklyScheduleSuccess(fetchResult.data));
        return fetchResult.data;
      } else {
        throw new Error(fetchResult.error || 'Failed to fetch updated schedule');
      }
    })
    .catch(error => {
      console.error('Failed to update weekly schedule:', error);
      dispatch(updateWeeklyScheduleError(storableError(error)));
      throw error;
    });
};

export const fetchWeeklyScheduleSummary = () => (dispatch, getState, sdk) => {
  dispatch(fetchWeeklyScheduleSummaryRequest());

  return getMyWeeklyScheduleSummary()
    .then(response => {
      dispatch(fetchWeeklyScheduleSummarySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchWeeklyScheduleSummaryError(storableError(e)));
      throw e;
    });
};

export const checkProviderAvailabilityAction = (providerId, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(checkAvailabilityRequest());

  return checkProviderAvailability(providerId, startDatetime, endDatetime)
    .then(response => {
      dispatch(checkAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(checkAvailabilityError(storableError(e)));
      throw e;
    });
};

export const doBatchCheckProviderAvailability = (providerIds, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(batchCheckAvailabilityRequest());

  return batchCheckProviderAvailability(providerIds, startDatetime, endDatetime)
    .then(response => {
      dispatch(batchCheckAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(batchCheckAvailabilityError(storableError(e)));
      throw e;
    });
};

export const checkDateRangeAvailability = (providerId, startDate, endDate, timeSlots) => (dispatch, getState, sdk) => {
  dispatch(checkAvailabilityRequest());

  return getProviderAvailabilityForDateRange(providerId, startDate, endDate, timeSlots)
    .then(response => {
      dispatch(checkAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(checkAvailabilityError(storableError(e)));
      throw e;
    });
};

export const getProviderStats = (providerId, startDate, endDate) => (dispatch, getState, sdk) => {
  dispatch(getAvailabilityStatsRequest());

  return getProviderAvailabilityStats(providerId, startDate, endDate)
    .then(response => {
      dispatch(getAvailabilityStatsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(getAvailabilityStatsError(storableError(e)));
      throw e;
    });
};

export const getProviderUpcomingAvailability = (providerId, daysAhead = 30) => (dispatch, getState, sdk) => {
  dispatch(fetchCalendarAvailabilityRequest());

  return getUpcomingAvailability(providerId, daysAhead)
    .then(response => {
      dispatch(fetchCalendarAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const checkWeeklyConflict = (providerId, params) => (dispatch, getState, sdk) => {
  return checkWeeklyTimeConflict(providerId, params)
    .then(response => {
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const checkCalendarOverlap = (providerId, params) => (dispatch, getState, sdk) => {
  return checkCalendarAvailabilityOverlap(providerId, params)
    .then(response => {
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const getFullProviderAvailability = (providerId, startDate, endDate) => (dispatch, getState, sdk) => {
  dispatch(fetchWeeklyScheduleRequest());
  // dispatch(fetchCalendarAvailabilityRequest());

  return getProviderFullAvailability(providerId, startDate, endDate)
    .then(response => {
      dispatch(fetchWeeklyScheduleSuccess({ data: response.weekly_schedule }));
      // dispatch(fetchCalendarAvailabilitySuccess({ data: response.calendar_availability }));
      return response;
    })
    .catch(e => {
      dispatch(fetchWeeklyScheduleError(storableError(e)));
      // dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const findAvailableProviders = (providerIds, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(batchCheckAvailabilityRequest());

  return getAvailableProviders(providerIds, startDatetime, endDatetime)
    .then(response => {
      dispatch(batchCheckAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(batchCheckAvailabilityError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search) => dispatch => {
  dispatch(fetchWeeklyScheduleRequest());

  return getMyWeeklyScheduleForForm()
    .then(response => {
      dispatch(fetchWeeklyScheduleSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchWeeklyScheduleError(storableError(e)));
      throw e;
    });
};